/**
 * Subscribe to a single comment by id, via Firestore onSnapshot.
 * Mirrors Flutter's _subscribeToContentReply flow.
 */

import { CommentService } from '@/domain/services/comment/commentService';
import type { CommentEntity } from '@/domain/entities/comment/commentEntity';
import type { Unsubscribe } from 'firebase/firestore';

export class SubscribeToCommentUseCase {
  constructor(private service = CommentService.getInstance()) {}

  execute(id: string, onChange: (comment: CommentEntity | null) => void): Unsubscribe {
    return this.service.subscribeToComment(id, onChange);
  }
}

export const subscribeToCommentUseCase = new SubscribeToCommentUseCase();
